export const pluralForm = (word: string, isPlural: boolean, suffix = "s") =>
  isPlural ? `${word.trim()}${suffix.trim()}` : word;
